/**
 * Component: ticket-note-edit
 * Main purpose: new note creation, including uploading files.
 * Allows admin to edit notes as well.
 */
<template>
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Editor de notas</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal"><i class="icon-close-cross-white icon-btn"></i></button>
        </div>
        <div class="modal-body" v-bind:class="{ 'half-opacity': isLoading }">
          <div class="row">
            <div class="col form-group">
              <textarea rows="7" class="form-control" placeholder="Escriba su comentario" v-model="content"></textarea>
            </div>
          </div>
          <div class="row mt-2 mb-2">
            <div class="col file-list" v-if="attachments.length > 0">
              <p class="file-list-item" v-for="attachment in attachments"><a v-bind:href="attachment.url" target="_blank"><i class="icon-file-link icon-text"></i>{{ attachment.filename ? attachment.filename : 'archivo ' + attachment.id }}</a></p>
            </div>
          </div>
          <hr>
          <div class="row mt-2">
            <div class="col">
              <input type="file" @change="onFileToUploadChange"></file-upload>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col">
              <p>Tamaño máximo de archivo: 8 MB</p>
            </div>
          </div>
          <div class="row mt-2" v-if="alertMessage">
            <div class="col">
              <div class="alert alert-warning">
                {{alertMessage}}
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col col-6 form-group">
              <button class="btn btn-primary btn-block" v-on:click="cancelEdit">DESCARTAR</button>
            </div>
            <div class="col col-6 form-group">
              <button class="btn btn-primary btn-block" v-on:click="saveNote">ACEPTAR</button>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
"use strict";

import apiService from '../../services/api-service.js';

const OPTION_DO_NOT_UPDATE_CONTENT      = 1;
const OPTION_DO_NOT_UPDATE_ATTACHMENTS  = 2;

/**
 * Default export
 */
export default {
  props: [
    "ticketId",
    "initNoteId",
    "modalId"
  ],
  data() {
    return {
      isLoading: false,
      content: "",
      attachments: [],
      alertMessage: "",
      noteId: this.initNoteId
    }
  },
  watch: {
    initNoteId(newId, oldId) {
      this.noteId = this.initNoteId;
      this.readNote();
    }
  },
  methods: {
    /**
     * GET request to get note and attachments
     */
    readNote: function(options) {
      this.alertMessage = "";
      if(this.noteId == 0) {
        this.content = "";
        this.attachments = [];
      } else {
        this.isLoading = true;
        axios({
          method: "get",
          url: apiService.getNoteApiUrl(this.ticketId, this.noteId)
        }).then(response => {
          this.isLoading = false;
          if(response.data.status == apiService.STATUS_OK) {
            if(!(options & OPTION_DO_NOT_UPDATE_CONTENT)) {
              this.content = response.data.content;
            }
            if(!(options & OPTION_DO_NOT_UPDATE_ATTACHMENTS)) {
              this.attachments = response.data.attachments;
            }
          } else {
            this.alertMessage = "No se han recibido los datos esperados.";
            console.log("Ajax error: " + response.data.messsage);
          }
        }).catch(error => {
          this.isLoading = false;
          this.alertMessage = "Ha ocurrido un error con el servidor.";
          console.log(error);
        });
      }
    },
    /**
     * Post request to save
     * The server is expected to set status_ref to 'sent' when saved
     * if status_ref is draft.
     * Despite being a POST, if noteId = 0 is sent, the server is expected
     * to create a new note and return noteId.
     */
    saveNote: function() {
      this.isLoading = true;
      this.alertMessage = "";
      axios({
        method: "post",
        url: apiService.getNoteApiUrl(this.ticketId, this.noteId),
        data: {
          content: this.content
        }
      }).then(response => {
        this.isLoading = false;
        if(response.data.status == apiService.STATUS_OK) {
          if(this.noteId == 0) {
            this.noteId = response.data.noteId;
          }
          location.reload();
        } else if(response.data.status == apiService.STATUS_VALIDATION_FAILED) {
          this.alertMessage = response.data.message;
        } else {
          console.log("Ajax error: " + response.data.messsage);
          this.alertMessage = "No se ha podido guardar la nota.";
        }
      }).catch(error => {
        this.isLoading = false;
        this.alertMessage = "Ha ocurrido un error con el servidor.";
        console.log(error);
      });
    },
    /**
     * PUT request to upload file for a note.
     * The server is expected to create a new note with status_ref = draft
     * if no noteId is set yet.
     * Expected return: noteId.
     */
    uploadFile(dataUrl, filename) {
      this.isLoading = true;
      this.alertMessage = "";
      axios({
        method: "put",
        url: apiService.getNoteUploadFileApiUrl(this.ticketId, this.noteId),
        data: {
          ticketId: this.ticketId,
          noteId: this.noteId,
          filename: filename,
          dataUrl: dataUrl
        }
      }).then( response =>  {
        if(response.data.status == apiService.STATUS_OK) {
          if(this.noteId == 0) {
            this.noteId = response.data.noteId;
          }
          this.readNote(OPTION_DO_NOT_UPDATE_CONTENT);
        } else {
          this.alertMessage = "No se ha podido guardar el archivo.";
          console.log(response.data.message);
        }
      }).catch(error => {
        this.alertMessage = "Ha ocurrido un error con el servidor.";
        console.log(error);
      });
    },
    /**
     * When file in the input type=file field changes
     * it reads data and class the uploadfile() method
     */
    onFileToUploadChange(event) {
      this.alertMessage = "";
      let file = event.target.files[0];
      let fileReader = new FileReader();
      if(file) {
        this.isLoading = true;
        fileReader.addEventListener('load', (function() {
          this.uploadFile(fileReader.result, file.name);
        }).bind(this));
        fileReader.addEventListener('onerror', (function() {
          this.isLoading = false;
          this.alertMessage = "Error: No se ha podido leer el archivo";
        }).bind(this));
        fileReader.readAsDataURL(file);
      }
    },
    /**
     * Cancel edit and close modal
     * Changes in 'content' are lost
     * Changes in files are mantaind, for they are already saved
     * If note was a draft (e.g. after upload a file), note gets lost
     * for the user but remains a a draft in the server.
     */
    cancelEdit() {
      this.alertMessage = "";
      $('#'+this.modalId).modal('hide');
      this.$emit("cancel-edit");
    }

  }
};

</script>
